import axios from "../axios";
import api from '../api';
import router from "@/router";

export const state = {
  user: {}
}

export const mutations = {
  SET_USER (state, payload) {
    state.user = payload
  }
}

export const actions = {
  async login ({ commit }, user) {
    try {
      const { data } = await axios.post(`${api.auth}/login`, user);
      commit('SET_USER', data);
      await router.push('/');
    } catch (err) {
      await router.push('/login');
    }
  },
  async get_user ({ commit }, next) {
    try {
      const { data: user } = await axios.get(`${api.auth}/login`);
      if (user.name) {
        commit('SET_USER', user);
        next();
      }
    } catch (err) {
      await router.push('/login');
    }
  },
  async logout ({ commit }) {
    try {
      await axios.delete(`${api.auth}/logout`);
      commit('SET_USER', {});
      await router.push('/login');
    } catch (err) {
      console.log(err)
    }
  }
}